import { useState } from 'react';
import { TextField } from '@habitech/keychain-atoms-inputs';
import { Button } from '@habitech/call-to-action';
import { GridItem } from 'src/components/common/grids';
import Loading from '../common/Loading/Loading';
import Editor from './Editor';
import { Title, SearchWrapper } from './styles';
import { getSeoUrl } from './../../apis/getSeoUrl';

const DescriptionLocation = () => {
    const [loading, setLoading] = useState(false);
    const [location, setLocation] = useState('');
    const [description, setDescription] = useState('');
    const [dataSeo, setDataSeo] = useState({});
    const [error, setError] = useState('');

    const handleSearch = () => {
        if (location && new URL(location)?.origin === window.location.origin) {
            setLoading(true);
            setDescription('');
            getSeoUrl(location)
                .then((res) => {
                    if (res.success) {
                        setDescription(res?.locationResponse?.description || '<p></p>');
                        setDataSeo({
                            country: 'MX',
                            sepomex_id: Number(res?.locationResponse?.sepomex_id),
                            purpose: res?.purposeValue || 3,
                            type: res?.typeValue || 0,
                            type_children: res?.type_children || 0,
                        });
                        setError('');
                    } else {
                        setError('No existe la ubicación en la base de datos');
                    }
                    setLoading(false);
                })
                .catch(() => {
                    setError('Error al encontrar la ubicación');
                    setLoading(false);
                });
        } else {
            setError('Verifique la url');
        }
    };

    const handleUrl = (str: string) => {
        setLocation(str);
        setDescription('');
        setError('');
    };

    return (
        <div>
            <Title>Descripcion de ubicaciones</Title>
            <SearchWrapper>
                <GridItem sm={4} md={6} lg={8}>
                    <TextField
                        dataId="search-url"
                        name="search-url"
                        label="Ubicación URL"
                        originType="pcom"
                        placeHolder="Digite la url"
                        innerLabel
                        defaultValue=""
                        onChange={(_, _value) => handleUrl(_value)}
                        error={Boolean(error)}
                        errorMessage={error}
                    />
                </GridItem>
                <GridItem sm={2} md={2} lg={2}>
                    <Button dataId="button-search" originType="pcom" size="large" fluid onClick={handleSearch}>
                        Buscar
                    </Button>
                </GridItem>
            </SearchWrapper>

            {loading && <Loading height="100%" />}
            {!error && description && <Editor dataSeo={dataSeo} description={description} />}
        </div>
    );
};

export default DescriptionLocation;
